import LogoutModal from '@features/games/modals/logout/logout';
export default LogoutModal;
